// extracted by mini-css-extract-plugin
export default {"imageWrapper":"vU-z","hovered":"wU-z","hoverImage":"xU-z","mainImage":"yU-z","imageNoBackground":"zU-z","fullSizeImage":"AU-z"};